import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import {
  FullscreenReferenceType,
  GlobalLocationStateType,
} from '../../types/types';
import Reference from './components/Reference';
import { useHistory, useLocation, useParams } from 'react-router';
import useRoutes from '../../hooks/useRoutes';
import { useSelectedFiltersContext } from '../../hooks/context/useSelectedFiltersContext';

interface DatasetDetailReferenceProps {
  fullscreenReference: FullscreenReferenceType | null;
  setFullscreenReference: Dispatch<
    SetStateAction<FullscreenReferenceType | null>
  >;
}

const DatasetDetailReference: FC<DatasetDetailReferenceProps> = ({
  fullscreenReference,
  setFullscreenReference,
}) => {
  const { setSelectedFilters } = useSelectedFiltersContext();
  const history = useHistory();
  const { pathname, state } = useLocation<GlobalLocationStateType>();
  const routes = useRoutes();
  const { datasetId, itemId, subsetId } = useParams<{
    datasetId: string;
    itemId?: string;
    subsetId?: string;
  }>();

  const isMasterReference =
    pathname === routes.masterFilterReference(datasetId);

  useEffect(() => {
    // Redirect back to the detailed filter page if user reloads the fullscreen reference page
    if (!fullscreenReference) {
      handleCloseFullscreenReference();
    }
  }, []);

  const handleOnSubmit = (name, datasetId, value) => {
    setSelectedFilters((v) =>
      v.map((filter) => {
        if (filter.name === name && filter.datasetId === datasetId) {
          return { ...filter, value };
        }
        return { ...filter };
      })
    );
    handleCloseFullscreenReference();
  };

  const handleCloseFullscreenReference = () => {
    setFullscreenReference(null);

    history.push(
      isMasterReference
        ? routes.datasetDetailMasterFilter(datasetId)
        : routes.subsetDetailSlaveFilter(
            datasetId,
            itemId ?? '',
            subsetId ?? ''
          ),
      state
    );
  };

  if (!isMasterReference && !itemId && !subsetId) {
    throw new Error('Item ID and subset ID are required for slave reference');
  }

  if (!fullscreenReference) {
    return null;
  }

  return (
    <Reference
      fullscreenReference={fullscreenReference}
      handleCloseFullscreenReference={handleCloseFullscreenReference}
      handleOnSubmit={(value) => {
        handleOnSubmit(
          fullscreenReference.name,
          fullscreenReference.datasetId,
          value
        );
      }}
    />
  );
};

export default DatasetDetailReference;
